import { Feature } from '@tencent/workbench';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import React, { lazy } from 'react';
import LazyBoundary from '@com/LazyBoundary';

const AnimationEditor = lazy(() => import(/* webpackChunkName: "lazyComponents" */ '@frame/components/animation-editor/index'));

@Feature()
export class AnimationFeature extends BaseDrawerFeature {
    public renderAnimationEditor() {
        return (
            <LazyBoundary
                renderAfterPromise={this.getAppService().editableServiceLayer?.animationEditorService.promise()}>
                <AnimationEditor
                    getAnimationEditorService={this.getAnimationEditorService}  />
            </LazyBoundary>
        );
    }

    private getAnimationEditorService = () => this.getAppService()
        .editableServiceLayer?.animationEditorService.dangerousInstance;
}
